import { useNavigate } from 'react-router';

import { styled } from 'styled-components';

import { AnimatedSpotlight } from 'apps-common/components/AnimatedSpotlight';
import { useGetAccount } from 'apps-common/hooks/useGetAccount';
import { track } from 'apps-common/utils/analytics';
import { membershipOfferingPrepaidMonths } from 'apps-common/utils/member';
import { t } from 'translations';
import { Button, Loader } from 'ui';
import { OuraLogo } from 'ui/components/Icons';
import { HeaderText } from 'ui/styles/text';

import { routes } from '../routes';

const GoToMembershipHubButton = styled(Button)`
  margin-top: 16px;
  background: none;
  color: white;
`;

export const RenewInactiveMembershipPage = () => {
  const navigate = useNavigate();
  const { data: accountData, isFetching: isFetchingAccount } = useGetAccount();

  if (isFetchingAccount) {
    return <Loader />;
  }

  const membershipOfferings = accountData?.membershipOffering;

  const prepaidMonths = membershipOfferingPrepaidMonths(membershipOfferings);

  const handleSubmit = () => {
    track({
      event: 'CTA Clicked',
      payload: {
        cta: 'next',
        action: 'renew_next_step',
      },
    });

    navigate(routes.reviewPaymentMethodForRenew);
  };

  return (
    <AnimatedSpotlight
      logo={<OuraLogo />}
      title={
        <HeaderText data-animate="heading" $fontSize="xxxlarge" $lineHeight="120%">
          {t('inactive_prepaid_pending_membership_renew_title', {
            month: prepaidMonths,
          })}
        </HeaderText>
      }
      subtitle={
        <HeaderText data-animate="subheading" as="h2" $fontSize="xlarge" $lineHeight="140%">
          {t('inactive_prepaid_pending_membership_renew_subtitle', {
            month: prepaidMonths,
          })}
        </HeaderText>
      }
      buttons={
        <>
          <Button data-animate="button" onClick={handleSubmit}>
            {t('membership_hub_renew_submit')}
          </Button>
          <GoToMembershipHubButton data-animate="button" onClick={() => navigate(routes.index)}>
            {t('inactive_prepaid_pending_membership_renew_go_to_membership_hub')}
          </GoToMembershipHubButton>
        </>
      }
    />
  );
};
